import React from "react";
import { Icon } from "@iconify/react";
import {
  matchPath,
  NavLink as RouterLink,
  useLocation,
} from "react-router-dom";
import { resolveUiAccent } from "../utils/uiAccents";

export default function NavSectionItem({ data }) {
  const { pathname } = useLocation();

  const isActive = () => {
    if (data.path === "/certificate-templates" && pathname.startsWith("/certificate-templates/issue")) {
      return false;
    }
    if (data.path === "/certificates" && pathname.startsWith("/certificate-templates/issue")) {
      return true;
    }
    if (data.exact) {
      return pathname === data.path;
    }
    if (Array.isArray(data.matches) && data.matches.length > 0) {
      return data.matches.some((match_path) =>
        match_path
          ? !!matchPath({ path: match_path, end: false }, pathname)
          : false,
      );
    }
    return data.path
      ? !!matchPath({ path: data.path, end: false }, pathname)
      : false;
  };

  const active = isActive();
  const className = `sidebar-nav-item${active ? " is-active" : ""}`;
  const accentKey = resolveUiAccent(data.accent || data.path);

  return (
    <RouterLink
      to={data.path}
      className={className}
      data-accent={accentKey}
      aria-current={active ? "page" : undefined}
    >
      <span className="sidebar-nav-item__icon">
        <Icon icon={data.icon} width={20} />
      </span>
      <span className="sidebar-nav-item__label">{data.title}</span>
      {active ? (
        <span className="sidebar-nav-item__indicator" aria-hidden="true" />
      ) : null}
    </RouterLink>
  );
}
